/**
 * User: Rob Richard
 * Date: 10/8/13
 * Time: 5:54 PM
 */
"use strict";

var PaymentMethod = require('bunsen/models/ecomm/PaymentMethodModel');
var ACH = module.exports = PaymentMethod.extend();
var SoaModel = require('bunsen/models/SoaModel');
var _ = require('underscore');

/**
 * @mixes bunsen.PaymentMethod
 * @class
 */
_.extend(ACH.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'ACH';
    },
    defaults : function () {
        return {
            apiType : PaymentMethod.prototype.defaults.apiType, //Only For Now
            paymentMethodType : 'ACH'
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/payment-methods/ACH.js
// module id = 182
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55